<template>
  <div class="modal">
    <Countries v-if="modalContent === 'countries'"></Countries>
    <div v-else>MODAL {{ modalContent }}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Countries from "@/components/modal/Countries.vue";

export default {
  name: "Modal",
  components: {
    Countries,
  },
  computed: {
    ...mapGetters({
      modalContent: "ui/modalContent",
    }),
  },
};
</script>

<style lang="scss" scoped>
.modal {
  height: calc(100% - #{$half-header-HEIGHT});
  padding-top: $half-header-HEIGHT;

  width: calc(100% - toRem(#{$landing-side-WIDTH}));
  margin-left: toRem(#{$landing-side-WIDTH});

  background-color: transparent;

  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.mobile,
.tablet {
  .modal {
    padding: 10.8vh 25vw 0 25vw;
    margin-left: 0;
    width: 100vw;
    height: 100%;
  }
}
</style>
